import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { BehaviorSubject, interval, map } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'refresh-connexion',
  templateUrl: './refresh-connexion.component.html',
  styleUrls: ['./refresh-connexion.component.scss']
})
export class RefreshConnexionComponent {
  constructor(private snackBar: MatSnackBar, @Inject(MAT_SNACK_BAR_DATA) public data: { refresh: () => void; duration: number }) {
    interval(1000)
      .pipe(
        map((int) => {
          const count = Math.round(this.data.duration / 1000 - int);
          if (count < 0) this.snackBar.dismiss();
          this.count.next(count);
        })
      )
      .subscribe();
  }

  count: BehaviorSubject<number> = new BehaviorSubject<number>(Math.round(this.data.duration / 1000));

  refresh(): void {
    this.data.refresh();
    this.snackBar.dismiss();
  }
}
